'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrencySymbol = undefined;

var _currencyConstants = require('./currencyConstants');

var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol() {
    var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var upperCurrencyCode = currencyCode.toUpperCase();
    var currency = _currencyConstants.CURRENCY[upperCurrencyCode];
    return currency ? currency.symbol : '' + upperCurrencyCode.substr(0, 2) + _currencyConstants.CURRENCY.default.symbol;
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/common/payment/currencyUtil.js
// module id = 325
// module chunks = 0